module.exports = __webpack_public_path__ + "7ae8558d90a3f4f070cd748c0c5f28bf.fbx";